import React from "react";
import { Card } from "@justworkshr/milo-core";
import AddressForm from "../../components/InternationalAddressForm/AddressForm";
import { useTranslation } from "react-i18next";
import useOnboardingForm from "../hooks/useOnboardingForm";

type Props = {
  handleBlur: (event: React.FocusEvent) => void;
  handleChange: (event: React.ChangeEvent) => void;
};

const HomeAddressCard = ({ handleBlur, handleChange }: Props) => {
  const { t } = useTranslation();
  const { memberData } = useOnboardingForm("contact-info");
  const formPath = "contactInfo.homeAddress";
  const workCountry = memberData?.workCountry;

  return (
    <div>
      <Card title={t("Home Address")}>
        <AddressForm
          handleBlur={handleBlur}
          handleChange={handleChange}
          formPath={formPath}
          supportedCountries={workCountry ? [workCountry] : []}
        />
      </Card>
    </div>
  );
};

export default HomeAddressCard;
